// headers.tsx - Fixed with Routing
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from "../assets/Icon 256.png";
import "../css/header.css";

const Header: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Navigation items configuration
  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/pricing', label: 'Pricing' },
    { path: '/about', label: 'About' },
    { path: '/contact', label: 'Contact' },
  ];

  // Handle logo click
  const handleLogoClick = () => {
    console.log('Logo clicked - redirecting to home');
    navigate('/');
    window.scrollTo(0, 0);
  };

  // Check if current path is active
  const isActivePath = (path: string) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  return (
    <header className="header-container">
      <div className="header-content">
        {/* Left Section - Logo */}
        <div className="header-left">
          <div className="logo-link" onClick={handleLogoClick}>
            <img 
              src={logo} 
              className="headerImg" 
              alt="RonCafeSuite Logo"
            />
            <span className="logo-text">RonCafeSuite</span>
          </div>
        </div>

        {/* Center Section - Navigation */}
        <nav className="header-nav">
          <ul className="nav-list">
            {navItems.map((item) => (
              <li key={item.path}>
                <Link 
                  to={item.path} 
                  className={`nav-link ${isActivePath(item.path) ? 'active' : ''}`}
                >
                  <span className="nav-label">{item.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;